import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Badge, Button, Card, CardBody, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';

import Loader from '../../components/Common/Loader';
import PlcSafetyCauseList from '../../components/Lists/PlcSafetyCauseList';
import { getPlcSafetyCauses, getPlcSafetyZones } from '../../store/actions';

const STATUS_LABEL = { ACTIVE: 'Activa', REARMED: 'Rearmada', RESOLVED: 'Resuelta' };
const STATUS_BADGE_COLOR = { ACTIVE: 'danger', REARMED: 'warning', RESOLVED: 'success' };

const causeColumns = (t) => [
  { label: t('Estado'), field: 'status', sort: 'disabled', width: 100 },
  { label: t('Evento'), field: 'event_name', sort: 'asc', width: 150 },
  { label: t('Trigger'), field: 'trigger_name', sort: 'asc', width: 150 },
  { label: t('Elemento'), field: 'element', sort: 'asc', width: 100 },
  { label: t('Zonas'), field: 'zones', sort: 'asc', width: 100 },
  { label: t('Activada'), field: 'activated_at', sort: 'asc', width: 120 },
  { label: t('Visto por última vez'), field: 'last_seen_at', sort: 'asc', width: 120 },
  { label: t('Rearmada'), field: 'rearmed_at', sort: 'asc', width: 120 },
  { label: t('Resuelta'), field: 'resolved_at', sort: 'asc', width: 120 },
];

class PlcSafetyCauses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      causeList: null,
      totalPages: 0,
    };
  }

  componentDidMount() {
    this.props.getPlcSafetyCauses(this.state.user, 20, 1);
    this.props.getPlcSafetyZones(this.state.user);
  }

  componentDidUpdate(prevProps) {
    if (this.props.causes !== prevProps.causes && this.props.causes) {
      this.setState({ totalPages: this.props.causes.totalPages || 0 });
      this.prepareData(this.props.causes.elements || []);
    } else if (this.props.causes && this.props.zones !== prevProps.zones) {
      this.prepareData(this.props.causes.elements || []);
    }
  }

  prepareData(causes) {
    const zoneNameByCode = {};
    (this.props.zones || []).forEach((z) => {
      zoneNameByCode[z.zone_code] = z.zone_name;
    });
    const columns = causeColumns(this.props.t);
    const rows = causes.map((c) => ({
      ...c,
      status: (
        <Badge color={STATUS_BADGE_COLOR[c.status]} className="font-size-13" pill>
          {this.props.t(STATUS_LABEL[c.status])}
        </Badge>
      ),
      zones: (c.zones || []).map((z) => zoneNameByCode[z.zone_code] || z.zone_code).join(', ') || '—',
      activated_at: c.activated_at ? new Date(c.activated_at).toLocaleString() : '—',
      last_seen_at: c.last_seen_at ? new Date(c.last_seen_at).toLocaleString() : '—',
      rearmed_at: c.rearmed_at ? new Date(c.rearmed_at).toLocaleString() : '—',
      resolved_at: c.resolved_at ? new Date(c.resolved_at).toLocaleString() : '—',
    }));
    this.setState({ causeList: { columns, rows } });
  }

  refresh(event) {
    event.preventDefault();
    this.setState({ causeList: null });
    this.props.getPlcSafetyCauses(this.state.user, 20, 1);
  }

  render() {
    if (!this.state.causeList) {
      return (
        <div className="loaderCenter">
          <Loader></Loader>
        </div>
      );
    }
    return (
      <div className="user-management">
        <Container fluid>
          <Button
            onClick={(event) => this.refresh(event)}
            color="primary"
            className="btn btn-primary buttonStatus usersButtons"
          >
            <i size="lg" className="mdi mdi-refresh"></i>
          </Button>
          <Button className="btn btn-secondary waves-effect waves-light buttonStatus usersButtons">
            <Link to="/plcSafetyEvents">{this.props.t('Ver eventos')}</Link>
          </Button>
          <Button className="btn btn-secondary waves-effect waves-light buttonStatus usersButtons">
            <Link to="/plcSafetyTriggers">{this.props.t('Ver triggers')}</Link>
          </Button>
          <Card>
            <CardBody>
              <PlcSafetyCauseList
                causeList={this.state.causeList}
                totalPages={this.state.totalPages}
                getPlcSafetyCauses={this.props.getPlcSafetyCauses}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { causes } = state.getPlcSafetyCauses;
  const { zones } = state.getPlcSafetyZones;
  return { causes, zones };
};

export default connect(mapStateToProps, { getPlcSafetyCauses, getPlcSafetyZones })(withNamespaces()(PlcSafetyCauses));
